import { render, staticRenderFns } from "./exportData.vue?vue&type=template&id=3f8cdb16&scoped=true"
import script from "./exportData.vue?vue&type=script&lang=js"
export * from "./exportData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8cdb16",
  null
  
)

export default component.exports